import BannerRepository from "./../api/index"
import "../types"

class BannerUseCase {
    constructor() {
        /** @type {BannerRepository}*/
        this.api = new BannerRepository()
    }

    /**
     *
     * @param typeBanner {string}
     * @return {Promise<{data: Banner, err: null}|{data: null, err: ErrorState}>}
     */
    async getOne(typeBanner = "homepage") {
        const {data, err} = await this.api.getOne(typeBanner)
        if (err && err === "record not found") {
            return {data: null, err: null}
        }
        return {data, err}
    }

    /**
     *
     * @param formData {FormData}
     * @return {Promise<{err: *}|{err: string}|{err: null}>}
     */
    async saveOne(formData) {
        return await this.api.saveOne(formData)
    }

    /**
     *
     * @param mainFile {File}
     * @param maximalImageSize {number}
     * @return {string}
     */
    validateFileData(mainFile, maximalImageSize) {
        const typeFile = mainFile.type.split("/")
        const [imageFormat, formatBytesExpected] = [["jpg", "jpeg", "png", "webp"], ["Bytes", "KB", "MB"]]
        if (typeFile[0] !== "image" || !imageFormat.includes(typeFile[1].toLowerCase())) {
            return "The format does not match, please check again"
        }
        const sizeFile = mainFile.size
        const currentSize = this._formatBytes(sizeFile).split(" ")
        if (!formatBytesExpected.includes(currentSize[1]) || (currentSize[1] === "MB" && +currentSize[0] > maximalImageSize)) {
            return "The file is too big, please check again"
        }
    }

    /**
     *
     * @param mainFile {File}
     * @param expectedImageHeightWidth {Object|ValidateFile}
     * @return {Promise}
     */
    validateImageHeightAndWidth(mainFile, expectedImageHeightWidth) {
        const img = new Image();
        img.src = window.URL.createObjectURL(mainFile);

        return new Promise((resolve, reject) => {
            let err = null
            img.onload = () => {
                if (img.naturalHeight > expectedImageHeightWidth.max.height ||
                    img.naturalWidth > expectedImageHeightWidth.max.width ||
                    img.naturalHeight < expectedImageHeightWidth.min.height ||
                    img.naturalWidth < expectedImageHeightWidth.min.width) {
                    err = "The image doesn't follow our guideline, please check again"
                }
                resolve({dataUrl: img.src, err: err})
            }
            img.onerror = reject
        })
    }

    /**
     * file size from input type file to bytes format
     * the result gonna be 850.59 KB, 2 MB, 10 GB
     * @param bytes {number}
     * @param decimals {number}
     * @return {string}
     * @private
     */
    _formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

}

export default new BannerUseCase()
